































import { IOci } from '@/contract/oci.contract';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class OCIInfo extends Vue {
  @Prop()
  public oci!: IOci;
}
